import { Text } from '@loadsmart/miranda-react'

export function MissingDate() {
  return (
    <>
      <Text variant="body-md-bold" color="color-text-tertiary">
        Missing date
      </Text>
      <Text variant="heading-md" color="color-text-primary">
        Missing time
      </Text>
    </>
  )
}
